<template>
  <v-container>
    <v-card class="text-center px-5 pb-5"
      ><v-card-text>
        <div
          class="text-h5 font-weight-medium text--primary"
          style="opacity: 0.8;"
        >
          Übungen von Studenten
        </div>
      </v-card-text>
      <ExerciseCards :exercises="exercises"></ExerciseCards>
    </v-card>
  </v-container>
</template>

<script>
import { useUserServiceInject } from "@/context";
import ExerciseCards from "@/components/ExerciseCards.vue";

export default {
  name: "CreateExerciseView",
  components: {
    ExerciseCards,
  },
  setup() {
    const { isStaff } = useUserServiceInject();
    return { isStaff };
  },
  data: () => ({
    profile: null,
    exercises: null,
    chapters: null,
  }),
  created() {
    if (!this.isStaff) {
      this.$router.push({ name: "exercises" });
    }

    this.$axios
      .get("chapters")
      .then((response) => (this.chapters = response.data));
    this.$axios.get("exercises").then((response) => {
      this.exercises = response.data.filter((e) => e.creator === "Student");
    });
  },
};
</script>

<style>
button {
  background-color: transparent !important;
}

textarea {
  border: none !important;
}
</style>

<style scoped>
.divider {
  margin-top: 0;
}
</style>
